import { SelfAlign } from "../../../../../base/styles";
import clsx from "clsx";

export const SelectSelfAlign = ({ title, value, className, onChange }:{
    title: string,
    value?: SelfAlign,
    className?: string,
    onChange: (value?: SelfAlign) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as SelfAlign;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={SelfAlign.Start}>Start</option>
                <option value={SelfAlign.End}>End</option>
                <option value={SelfAlign.Center}>Center</option>
                <option value={SelfAlign.Baseline}>Baseline</option>
                <option value={SelfAlign.Stretch}>Stretch</option>
            </select>
        </div>
    )
}